import { Component, Element } from '@stencil/core';

@Component({
    tag: 'scspies-menu-link'
})
export class MenuLink {

    @Element() el!: HTMLElement;

    private a!: HTMLAnchorElement;

    private isAndroidTablet = false;
    private preventNextClick = false;

    componentDidLoad(): void {
        this.a = this.el.querySelector('a') as HTMLAnchorElement;

        this.isAndroidTablet = this._isAndroidTablet();
        this.preventNextClick = this.isAndroidTablet;
        this.a.addEventListener('click', this.handleClick);
    }

    disconnectedCallback(): void {
        this.a.removeEventListener('click', this.handleClick);
    }

    private handleClick = (event: Event) => {
        if (this.preventNextClick) {
            event.preventDefault();
            this.preventNextClick = false;
        } else if (this.isAndroidTablet) {
            this.preventNextClick = true;
        }
    }

    private _isAndroidTablet(): boolean {
        const offcanvasButton = document.querySelector('scspies-offcanvas-button') as HTMLScspiesOffcanvasButtonElement;

        return (typeof window.ontouchstart !== 'undefined')
            && navigator.userAgent.toLowerCase().match(/android/) !== null
            && (offcanvasButton !== undefined && window.getComputedStyle(offcanvasButton).display === 'none');
    }

}
